import { motion } from "framer-motion";
import AIAvatar from "./AIAvatar";

export default function WelcomeScreen({ welcome, onPickSuggestion }) {
  const name = (welcome?.user_name || "").split(" ")[0] || "there";
  const suggestions = welcome?.suggestions || [];

  return (
    <motion.div
      className="ai-welcome"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.28 }}
    >
      <div className="ai-welcome-hero">
        <AIAvatar size={52} />
        <h2 className="ai-welcome-title">
          Hello <span className="ai-welcome-name">{name}</span> 👋
        </h2>
        <p className="ai-welcome-sub">How can I help you today?</p>
      </div>

      <div className="ai-suggestion-grid">
        {suggestions.map((s, i) => (
          <motion.button
            key={i}
            className="ai-suggestion"
            type="button"
            onClick={() => onPickSuggestion(s.label)}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.22, delay: i * 0.04 }}
            whileHover={{ y: -2 }}
          >
            <span className="ai-suggestion-icon">{s.icon || "✨"}</span>
            <span className="ai-suggestion-label">{s.label}</span>
          </motion.button>
        ))}
      </div>

      <div className="ai-welcome-footer">
        <span className="ai-welcome-badge">
          <span className="ai-welcome-dot" />
          {welcome?.provider === "anthropic"
            ? "Powered by Claude"
            : welcome?.provider === "openai"
              ? "Powered by ChatGPT"
              : "Powered by Brixigo Intelligence"}
        </span>
      </div>
    </motion.div>
  );
}
